import React, { useEffect, useRef, useState } from 'react'
import { ArrowUpRight } from 'lucide-react';
import { useInView } from 'react-intersection-observer';
import { motion } from 'framer-motion';
import { Link, useNavigate, useNavigationType } from 'react-router-dom';

// mobile app
import fitme from '../../../assets/mockups2/mockups/fitme.jpeg'
import gbc from '../../../assets/mockups2/mockups/gbc.png'
import rafik from '../../../assets/mockups2/mockups/ABU RAFIK BUTCHER.png'
import AfroNeta from '../../../assets/mockups2/mockups/AfroNeta.png'
import ANIATPNA from '../../../assets/mockups2/mockups/ANIATPNA Mobile App.png'
import zipzap from '../../../assets/mockups2/mockups/Zipzap talk.png'
import aura from '../../../assets/mockups2/mockups/Aura VPN.png'
import BlinkBack from '../../../assets/mockups2/mockups/BlinkBack.png'
import blush from '../../../assets/mockups2/mockups/blush.png'
import BLOCKATIE from '../../../assets/mockups2/mockups/BLOCKATIE.png'
import flaty from '../../../assets/mockups2/mockups/Flaty.pk.png'
import gdrive from '../../../assets/mockups2/mockups/Gdrive Final.png'
import harmon from '../../../assets/mockups2/mockups/Harmonized1.png'
import meCloset from '../../../assets/mockups2/mockups/MeCloset.png'
import mego from '../../../assets/mockups2/mockups/Mego Final.png'
import noly from '../../../assets/mockups2/mockups/Noly.png'
import pakTruck from '../../../assets/mockups2/mockups/PakTRuck.png'
import quickly from '../../../assets/mockups2/mockups/Quickly final mockup.png'
import revealit from '../../../assets/mockups2/mockups/Revealt.png'
import sbp from '../../../assets/mockups2/mockups/Service Booking App.png'
import helth from '../../../assets/mockups2/mockups/So Helthful.png'
import filsx from '../../../assets/mockups2/mockups/filsx.jpg'

// web development
import web1 from '../../../assets/web/web/web (1).png'
import web2 from '../../../assets/web/web/web (2).png'
import web3 from '../../../assets/web/web/web (3).png'
import web4 from '../../../assets/web/web/web (4).png'
import web5 from '../../../assets/web/web/web (5).png'
import web6 from '../../../assets/web/web/web (6).png'
import web7 from '../../../assets/web/web/web (7).png'
import web8 from '../../../assets/web/web/web (8).png'
import web9 from '../../../assets/web/web/Fresh Steps.png'
import web10 from '../../../assets/web/web/web (10).png'
import web11 from '../../../assets/web/web/web (11).png'
import web12 from '../../../assets/web/web/web (12).png'
import web13 from '../../../assets/web/web/web (13).png'
import web14 from '../../../assets/web/web/web (14).png'
import web15 from '../../../assets/web/web/web (15).png'
import web16 from '../../../assets/web/web/web (16).png'
import web17 from '../../../assets/web/web/web (17).png'
import web18 from '../../../assets/web/web/web (18).png'
import web19 from '../../../assets/web/web/web (19).png'
import web20 from '../../../assets/web/web/web (20).png'
import web21 from '../../../assets/web/web/web (21).png'
import flatyweb from '../../../assets/web/web/flaty.png'

import brum from '../../../assets/web/web/brum-mobile.png'
import diamond from '../../../assets/web/web/diamond.png'
import visaera from '../../../assets/web/web/visaera.png'
import techkyo from '../../../assets/web/web/techkyo.png'
import meqr from '../../../assets/web/web/me-qr.png'
import tutor from '../../../assets/web/web/tutor-site.png'
import oxmmarket from '../../../assets/web/web/oxmmarket.png'
import glassgow from '../../../assets/web/web/glasgow-mobile.png'

// Fisher-Yates shuffle — returns a new shuffled array, never mutates the original
const shuffleArray = (array) => {
    const arr = [...array];
    for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
};

// Build id -> type lookup so we know which UI/UX cards are "web" vs "app"
const buildTypeMap = (projectsObj) => {
    const map = {};
    projectsObj["Mobile Apps"]?.forEach((p) => { map[p.id] = 'app'; });
    projectsObj["Web Development"]?.forEach((p) => { map[p.id] = 'web'; });
    return map;
};

// Interleave web/app items (web, app, web, app...) and push excluded ids to the back
const interleaveShuffle = (array, typeMap, excludeIds = []) => {
    const webItems = shuffleArray(array.filter((p) => typeMap[p.id] === 'web'));
    const appItems = shuffleArray(array.filter((p) => typeMap[p.id] === 'app'));
    const otherItems = shuffleArray(array.filter((p) => !typeMap[p.id]));

    const result = [];
    const maxLen = Math.max(webItems.length, appItems.length);
    for (let i = 0; i < maxLen; i++) {
        if (webItems[i]) result.push(webItems[i]);
        if (appItems[i]) result.push(appItems[i]);
    }
    result.push(...otherItems);

    if (excludeIds.length) {
        const rest = result.filter((p) => !excludeIds.includes(p.id));
        const pushedBack = result.filter((p) => excludeIds.includes(p.id));
        return [...rest, ...pushedBack];
    }
    return result;
};

const Portfoliopage = ({ showMoreButton = true }) => {
    const navigate = useNavigate();
    const navType = useNavigationType(); // 'POP' = back/forward button
    const sectionRef = useRef(null);
    const STATE_KEY = `portfolioState:${typeof window !== 'undefined' ? window.location.pathname : ''}`;

    // Tracks how many times "UI / UX Design" has been clicked, and caches
    // the last shuffled list so clicks 2-5 reuse the same order
    const uiUxClickCountRef = useRef(0);
    const uiUxCachedListRef = useRef(null);

    const images = [
    // app 
    fitme, gbc, rafik, AfroNeta, ANIATPNA, 
    aura, BlinkBack, blush, BLOCKATIE, flaty, gdrive,
    harmon, meCloset, mego, noly, pakTruck, quickly,
    revealit, sbp, helth, filsx,
    //web
    web1, web2, web3, web4, web5, web6, web7, web8, web9, 
    web10, web11, web12, web13, web14, web15, web16, web17,
    web18, web19, web20, web21, flatyweb, brum, diamond, visaera, techkyo, meqr, tutor, glassgow, oxmmarket
    ];
     useEffect(() => {
    images.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, []);

const projects = {
    "Mobile Apps": [
         {
            id: 'gbc',
            image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1784114356/GBC_qyt1gs.png',
            title: 'GBC',
            description: "GBC connects learners with verified mentors through live sessions and real-time collaboration.",
        },
         {
            id: 'butcher-shop',
            image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842882/ABU_RAFIK_BUTCHER_zmtlmz.png',
            title: 'Abu Rafiq Butcher Shop',
            description: "Abu Rafiq Butcher offers food ordering with delivery, pickup, dine-in, and secure payments.",
        },
        {
            id: 'afroneta',
            image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842887/AfroNeta_cpswek.png',
            title: 'AfroNeta',
            description: "AfroNeta streamlines users, content, payments, analytics, and community management.",
        },
        {
            id: 'anipartna',
            image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842882/ANIATPNA_Mobile_App_yspt0j.png',
            title: 'Anipartna Mobile App',
            description: "Anipartna lets users buy, sell, and invest in properties through a trusted marketplace.",
        },
        {
            id: 'auravpn',
            image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1784114356/Aura_VPN_Updated_v7nlme.png',
            title: 'aura VPN',
            description: "Fast, secure VPN powered by WireGuard and Supabase for private browsing.", 
        },
         {
            id: 'on-the-dot',
            image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842888/Service_Booking_App_zi2i3n.png',
            title: 'service booking app',
            description: "Simplifies service discovery, booking, scheduling, and business management.", 
        },
        {
            id: 'revealit',
            image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842886/Revealt_hpnmlu.png',
            title: 'revealit',
            description: "RevealIt scans products to explain ingredients, allergens, and safety insights.",
        },
        {
            id: 'noly',
            image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1784029767/Noly_nbyhyw.png',
            title: 'noly',
            description: "Noly converts audio into accurate transcripts and concise summaries.",
        },
        {
            id: 'gdrive',
            image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842882/Gdrive_Final_rl26qk.png',
            title: 'GDrive',
            description: "Master the German driving exam with interactive quizzes, videos, and images.",    
        },
        {
            id: 'paktruck',
            image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842885/PakTRuck_gngafd.png',
            title: 'pak truck',
            description: "Pak Truck simplifies buying, selling, and promoting trucks, buses, and spare parts.",
        },
        {
            id: 'blink-back',
            image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842883/BlinkBack_rnjct0.png',
            title: 'blink back',
            description: "BlinkBack helps users capture and relive special moments with ease.",
        },
        {
            id: 'flaty',
            image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842884/Flaty.pk_r8sxhu.png',
            title: 'Flaty.pk',
            description: "Flaty lets users buy, sell, and explore properties with trusted listings and secure transactions.", 
        },
        {
            id: 'meCloset',
            image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842884/MeCloset_kdtflk.png',
            title: 'Me Closet',
            description: "MeCloset helps users organize outfits, create clothing pairs, and plan looks.", 
        },
         {
    id: "fitme",
    image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1783593243/Tanbnil_tlfije.png",
    title: "FitMe - AI Outfit Stylist",
    description: "AI-powered wardrobe app for smart outfit curation, weekly style planning, and personalized fashion recommendations.",
},
        {
    id: 'safe-choice',
    image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842886/SafeChoice_nk72vp.png',
    title: 'SafeChoice',
    description: "SafeChoice scans products for health scores, allergen alerts, and smarter choices.",
},
// {
//     id: 'yazboz',
//     image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1784114357/YAZBOZ_Updated_ri45bn.png',
//     title: 'Yazboz',
//     description: "Yazboz tracks Okey scores, live matches, and complete game history with real-time updates.",
// },
{
    id: "mego",
    image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842885/Mego_cu6ids.png",
    title: "MEGO - Buy & Sell Marketplace",
    description: "Marketplace for smartphones, vehicles, and property listings.",
},
{
    id: "mb-travel",
    image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1783669931/MB_Travel_Tanbnil_kyswqf.png",
    title: "MB Travel - Visa & Immigration",
    description: "Digital visa applications with secure document tracking.",
},
    ],

    "UI / UX Design": [
        {
            id: 'gbc',
            image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1784114356/GBC_qyt1gs.png',
            title: 'GBC',
            description: "GBC connects learners with verified mentors through live, collaborative learning.",
        },
         {
            id: 'butcher-shop',
            image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842882/ABU_RAFIK_BUTCHER_zmtlmz.png',
            title: 'Abu Rafiq Butcher Shop',
            description: "Food ordering with delivery, pickup, dine-in, and secure payments.",
        },
         {
            id: "supply-king",
            image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842975/Supplyking_hky20r.png',
            title: 'supply king',
            description: "Simplifies bulk ordering, supply management, and reliable order tracking.",
        },
        {
            id: 'afroneta',
            image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842887/AfroNeta_cpswek.png',
            title: 'AfroNeta',
            description: "Streamlines users, content, payments, analytics, and community management.",
        },
        {
            id: 'anipartna',
            image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842882/ANIATPNA_Mobile_App_yspt0j.png',
            title: 'Anipartna Mobile App',
            description: "Buy, sell, and invest in properties through a trusted digital marketplace.",
        },
         {
            id: "we-scale-hq",
            image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842978/Wescale_slq16q.png',
            title: 'we scale hq',
            description: "Fix sales leaks, train teams, and scale faster with We Scale HQ.",
        },
        {
            id: 'aura-vpn',
            image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1784114356/Aura_VPN_Updated_v7nlme.png',
            title: 'aura VPN',
            description: "A fast and secure VPN with Wire Guard for high-speed browsing and Supabase for reliable data protection.", 
        },
        {
            id: 'flatty',
            image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842884/Flaty.pk_r8sxhu.png',
            title: 'Flaty.pk',
            description: "Buy, sell, and explore properties with trusted listings and secure transactions.", 
        },
        {
            id: "ubk-towing",
            image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842975/UBK_Adman_Panel_c2pe1r.png',
            title: 'ubk towing',
            description: "Streamlines transportation with vehicle management, inspections, analytics, and document tracking.",
        },
        {
            id: 'revealit',
            image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842886/Revealt_hpnmlu.png',
            title: 'revealit',
            description: "Scan products for ingredients, allergen alerts, and safety insights.",
        },
        {
            id: 'noly',
            image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1784029767/Noly_nbyhyw.png',
            title: 'noly',
            description: "Transform audio into accurate transcripts and smart summaries.",
        },
        {
            id: 'gdrive',
            image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842882/Gdrive_Final_rl26qk.png',
            title: 'GDrive',
            description: "Master the German driving exam with interactive quizzes, videos, and images.",    
        },
        {
            id: "pak-truck",
            image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842973/Pak_Truck_2_nztuwr.png',
            title: 'pak truck',
            description: "Buy, sell, and promote trucks, buses, and spare parts effortlessly.",
        },
        {
            id: 'paktruck',
            image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842885/PakTRuck_gngafd.png',
            title: 'pak truck',
            description: "Buy, sell, and promote trucks, buses, and spare parts effortlessly.",
        },
        {
            id: 'blink-back',
            image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842883/BlinkBack_rnjct0.png',
            title: 'blink back',
            description: "Capture and relive special moments through a simple, intuitive experience.",
        },
        {
            id: 'meCloset',
            image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842884/MeCloset_kdtflk.png',
            title: 'Me Closet',
            description: "Organize outfits, create clothing pairs, and plan looks with ease.", 
        },
        {
            id: 'on-the-dot',
            image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842888/Service_Booking_App_zi2i3n.png',
            title: 'service booking app',
            description: "Simplifies service discovery, booking, scheduling, and business management.", 
        },
        {
    id: "fitme",
    image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1783593243/Tanbnil_tlfije.png",
    title: "FitMe - AI Outfit Stylist",
    description: "AI-powered wardrobe app for smart outfit curation, weekly style planning, and personalized fashion recommendations.",
},
    ],
    
    "Web Development": [
        {
            id: "ubk-towing",
            image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842975/UBK_Adman_Panel_c2pe1r.png',
            title: 'ubk towing',
            description: "UBK streamlines transportation with vehicle management, inspections, analytics, and document tracking.",
        },
        {
            id: "flaty-web",
            image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816184/Tanbnil_yujxor.png',
            title: 'Flaty.pk',
            description: "Flaty lets users explore, buy, and sell properties with trusted listings and secure transactions.",
        },
        {
    id: "earning-dashboard",
    image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842977/White_vx9z2f.png',
    title: 'earning dashboard',
    description: "Monitor revenue, financial performance, and real-time insights through an advanced analytics dashboard.",
},
       {
  id: "pak-truck",
  image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842973/Pak_Truck_2_nztuwr.png',
  title: "Pak Truck",
  description:
    "A responsive logistics website showcasing trucking services, fleet solutions, and business operations.",
},
        {
            id: "supply-king",
            image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842975/Supplyking_hky20r.png',
            title: 'supply king',
            description: "Supply King simplifies bulk ordering, supply management, and order tracking.",
        },
        {
            id: "we-scale-hq",
            image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842978/Wescale_slq16q.png',
            title: 'we scale hq',
            description: "Fix sales leaks, train teams, and scale business growth faster.",
        },
        {
    id: "glasgow-mobile-car-wash",
    image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842972/Glasgow_mobile_car_wash_e3sbco.png",
    title: "Glasgow Mobile Car Wash Website",
    description: "Book professional mobile car washing and detailing services with ease.",
},
        {
            id: "visaera",
            image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816205/Tanbnil_idqvvd.png',
            title: 'visaera worldwide',
            description: "Access global visa guidance, applications, and travel requirements in one platform.",
        },
        {
    id: "developers-door",
    image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1783945345/Developers_rf6zer.png",
    title: "Developers Door",
    description: "A modern platform for developers to learn, showcase projects, and explore careers.",
},
{
    id: "burn-mobile-tyres",
    image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842965/Brum_mobile_Tyre_hlprm1.png",
    title: "Burn Mobile Tyres",
    description: "24/7 emergency mobile tyre fitting service across Birmingham with RAC-approved technicians and instant roadside assistance.",
},
{
    id: "specoptics",
    image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842977/SpecOptic_cioqmq.png",
    title: "SpecOptics - Premium Eyewear",
    description: "Discover stylish frames, designer brands, and expert eye care through a seamless online optical shopping experience.",
},
{
    id: "mobile-emissions",
    image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1783945406/Mobile_Emission_fpsdm1.png",
    title: "Mobile Emissions Testing",
    description: "Certified on-site emission inspections for heavy trucks and commercial fleets with fast 30-minute testing across the GTA.",
},
{
    id: "oxz-market",
    image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1784026766/Oxmmarket_blm1sl.png",
    title: "OXZ Market - Forex Trading",
    description: "Advanced online trading platform for global forex, stocks, commodities, and cryptocurrencies with expert analytical tools.",
},
{
    id: "sohagan",
    image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842972/Sohaagan_hxuurb.png",
    title: "Sohagan - Luxury Jewellery",
    description: "Timeless handcrafted bridal jewellery, premium gold collections, and exclusive custom designs with worldwide insured shipping.",
},
{
    id: "diamond-yarn",
    image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842973/Diamond_Yarm_brenll.png",
    title: "Diamond Yarn - Premium Yarns",
    description: "Luxury knitting threads, handcrafted needles, curated patterns, and universal fiber accessories for creative crafting needs.",
},
{
    id: "vendcomm",
    image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842979/VendComm_Landing_Page_ry98uz.png",
    title: "VendComm - Event Management",
    description: "Centralize invoices, manage vendor communications, track event timelines, and streamline team coordination on one powerful platform.",
},
{
    id: "vendcomm-dashboard",
    image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842976/VendComm_Dashboard_xuugrm.png",
    title: "VendComm Dashboard - Vendor Management",
    description: "Streamline marketing campaigns, track event budgets, assign tasks, and generate digital invoices on a powerful vendor dashboard.",
},
        {
            id: "fieldtrip-link",
            image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842967/FieldTrip_Link_qv5ypy.png',
            title: 'fieldTrip link',
            description: "Simplifying safe, reliable, and efficient school transportation for students.",
        },
       
    ],
};


// id -> 'web' | 'app' lookup, used to interleave UI/UX Design cards
const typeMap = buildTypeMap(projects);

// load all images
const allImages = Object.values(projects).flat().map(p => p.image);

useEffect(() => {
  allImages.forEach((src) => {
    const img = new Image();
    img.src = src;
  });
}, []);

const categoryLabels = {
  "Mobile Apps": {
    mobile: "Mobile",
    desktop: "Mobile Apps"
  },
  "UI / UX Design": {
    mobile: "UI / UX",
    desktop: "UI / UX Design"
  },
  "Web Development": {
    mobile: "Web",
    desktop: "Web Development"
  }
};
    const isMobile = typeof window !== "undefined" && window.innerWidth < 640;

const getLabel = (category) => {
  return isMobile
    ? categoryLabels[category]?.mobile || category
    : categoryLabels[category]?.desktop || category;
};

const [activeCategory, setActiveCategory] = useState(
  sessionStorage.getItem('activeCategory') || Object.keys(projects)[0]
);

const [showAll, setShowAll] = useState(false);

// ✅ UPDATED - Conditional slice based on showMoreButton
const [displayedProjects, setDisplayedProjects] = useState(() => {
  const startCategory = sessionStorage.getItem('activeCategory') || Object.keys(projects)[0];

  // Coming back from a detail page: restore the exact same cards in the same order
  try {
    const saved = JSON.parse(sessionStorage.getItem(STATE_KEY));
    if (navType === 'POP' && saved?.category === startCategory && saved.ids?.length) {
      const restored = saved.ids
        .map((id) => projects[startCategory].find((p) => p.id === id))
        .filter(Boolean);
      if (restored.length) return restored;
    }
  } catch (e) {}

  let projectsList;
  if (startCategory === "UI / UX Design") {
    uiUxClickCountRef.current = 1; // counts as the first "click"
    projectsList = interleaveShuffle(projects[startCategory], typeMap);
    uiUxCachedListRef.current = projectsList;
  } else {
    projectsList = projects[startCategory];
  }
  
 
  return showMoreButton ? projectsList.slice(0, 6) : projectsList;
});

// Save the section position + card order right before leaving for a detail page
const saveScrollState = () => {
  const el = sectionRef.current;
  if (!el) return;
  const top = el.getBoundingClientRect().top + window.scrollY;
  try {
    sessionStorage.setItem(STATE_KEY, JSON.stringify({
      offset: window.scrollY - top,          // distance from the section's top
      category: activeCategory,
      ids: displayedProjects.map((p) => p.id),
    }));
  } catch (e) {}
};

// Restore the position on back navigation (re-applied while the layout settles)
useEffect(() => {
  if (navType !== 'POP') return;
  let saved = null;
  try { saved = JSON.parse(sessionStorage.getItem(STATE_KEY)); } catch (e) {}
  if (!saved || !sectionRef.current) return;

  const prevRestoration = window.history.scrollRestoration;
  window.history.scrollRestoration = 'manual'; // stop the browser fighting us

  let cancelled = false;
  const stop = () => { cancelled = true; };
  window.addEventListener('wheel', stop, { passive: true });
  window.addEventListener('touchstart', stop, { passive: true });

  const restore = () => {
    if (cancelled || !sectionRef.current) return;
    const top = sectionRef.current.getBoundingClientRect().top + window.scrollY;
    window.scrollTo(0, top + saved.offset);
  };

  restore();
  const interval = setInterval(restore, 100);
  const end = setTimeout(() => {
    clearInterval(interval);
    sessionStorage.removeItem(STATE_KEY); // so a later unrelated "back" doesn't jump here
  }, 2000);

  return () => {
    clearInterval(interval);
    clearTimeout(end);
    window.removeEventListener('wheel', stop);
    window.removeEventListener('touchstart', stop);
    window.history.scrollRestoration = prevRestoration;
  };
}, []);

// Save to sessionStorage whenever activeCategory changes
useEffect(() => {
  sessionStorage.setItem('activeCategory', activeCategory);
}, [activeCategory]);

useEffect(() => {
  const handleUnload = () => sessionStorage.removeItem('activeCategory');
  window.addEventListener('beforeunload', handleUnload);
  return () => window.removeEventListener('beforeunload', handleUnload);
}, []);


  const { ref, inView } = useInView({
        triggerOnce: true,
        threshold: 0,    
    });

    const hasAnimated = useRef(false);

useEffect(() => {
  if (inView) hasAnimated.current = true;
}, [inView]);

    const container = {
        hidden: {},
        visible: {
            transition: {
            staggerChildren: 0.3,
            },
        },
    };
    const items = {
        hidden: { y: 60, opacity: 0 },
        visible: { y: 0, opacity: 1 },
    };

  const zoomIn = {
  hidden: {
    opacity: 0,
    scale: 0.15,
    y: 60,
  },
  visible: {
    opacity: 1,
    scale: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: "easeOut",
    },
  },
};

const [hovered, setHovered] = useState(false)
const [hoverId, setHoverId] = useState('')

// Function to handle category change
// Function to handle category change
const handleCategoryChange = (category) => {
  // Capture ids currently shown BEFORE switching (still holds old category's data)
  const prevIds = displayedProjects.map((p) => p.id);

  setActiveCategory(category);
  setShowAll(false);

  let projectsList;

  if (category === "UI / UX Design") {
    uiUxClickCountRef.current += 1;

    // Shuffle on the 1st click, then every 6th click (6, 12, 18...) — otherwise reuse cached order
    const shouldShuffle =
      uiUxClickCountRef.current === 1 ||
      uiUxClickCountRef.current % 6 === 0 ||
      !uiUxCachedListRef.current;

    if (shouldShuffle) {
      projectsList = interleaveShuffle(projects[category], typeMap, prevIds);
      uiUxCachedListRef.current = projectsList;
    } else {
      projectsList = uiUxCachedListRef.current;
    }
  } else {
    projectsList = projects[category];
  }

  // ✅ UPDATED - Conditional slice based on showMoreButton
  setDisplayedProjects(showMoreButton ? projectsList.slice(0, 6) : projectsList);
};

// Function to handle Show More - Navigate to Portfolio page
const handleShowMore = () => {
  navigate('/portfolio');
};

  return (
      <section ref={sectionRef} className=" mt-10 sm:mt-15  bg-white">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
    <div className="text-center max-w-4xl mx-auto mb-6">
    <motion.h2
    variants={zoomIn}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        transition={{ delay: 0.15 }}
   className="text-3xl   sm:text-4xl md:text-5xl font-semibold tracking-tight text-[#333]">Our Projects !</motion.h2>
<motion.p
    variants={zoomIn}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true }}
    transition={{ delay: 0.15 }}
    className="mt-4 leading-[160%] text-sm sm:text-lg text-[#333333CC] w-full max-w-[800px] mx-auto text-center"
>
    We comprehend the challenges faced by our clients and deliver the required results.
    <br />
    To find out how we can assist you as well, look at some of our work!
</motion.p>
    </div>
<div className="mt-8 mb-8 w-full px-4">
  <div className="flex items-center justify-center gap-2 sm:gap-3 md:gap-4 w-full lg:justify-center">
    {Object.keys(projects).map((category) => (
      <button
        key={category}
        onClick={() => handleCategoryChange(category)}
        className={`flex-1 lg:flex-none lg:w-[150px] xl:w-[200px]
        whitespace-nowrap rounded-xl border font-medium transition-all duration-300
        px-3 py-2 text-sm
        sm:px-5 sm:py-2.5 sm:text-sm
        md:px-6 md:py-3 md:text-base
        ${
          activeCategory === category
            ? "bg-[#4DC3D1] border-[#4DC3D1] text-white"
            : "bg-white border-[#E5E7EB] text-[#333333] hover:border-[#4DC3D1]/50"
        }`}
      >
        {getLabel(category)}
      </button>
    ))}
  </div>
</div>
    <div>
      {/* cards */}
      <motion.div 
       ref={ref}
    variants={container}
    initial="hidden"
    animate={hasAnimated.current ? "visible" : (inView ? "visible" : "hidden")}
      className="grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-8 max-w-6xl mx-auto my-12">
       {displayedProjects.map((item, index) => (
          <Link key={item.id} to={`/portfolio/${item.id}`}
            state={{ category: activeCategory }}
            onClick={saveScrollState}
        >

  <motion.div
    key={index}
    onMouseEnter={() => {setHovered(true); setHoverId(item.id)}}
    onMouseLeave={() => {setHovered(false); setHoverId('')}}
    className="relative rounded-xl overflow-hidden shadow-[0_2px_16px_0_#E3EBFC] hover:shadow-[0_4px_20px_0_#E3EBFC] transition-all duration-300 cursor-pointer "
  >
    <img
      src={item.image}
      alt={item.title}
      className={`w-full h-auto object-contain transition-transform duration-500 ${hovered && hoverId === item.id? 'scale-110' : ''}`}
    />

    <div className={`absolute inset-0 bg-gradient-to-t from-black via-black/20 to-transparent ${hovered && hoverId === item.id? 'opacity-100' : 'opacity-0 '} transition-opacity duration-300`}></div>

    <div className={`absolute inset-x-6 bottom-6 text-white transition-all duration-300 ${hovered && hoverId === item.id ? 'translate-y-0 opacity-100' : 'translate-y-5 opacity-0'}`}>
  <h3 className="text-2xl font-semibold mb-1 capitalize">
    {item.title}
  </h3>
  <p className="text-sm mb-2">
    {item.description}
  </p>
  <a href={item.id} className="absolute inset-0">
    <span className="sr-only">View {item.title}</span>
  </a>
</div>
  </motion.div>
  </Link>
))}
      </motion.div>

      {/* Show More Button - Navigate to Portfolio Page */}
      {showMoreButton && !showAll && displayedProjects.length < projects[activeCategory]?.length && (
        <div className="text-center mt-8 mb-10">
          <button
            onClick={handleShowMore}
            className="px-8 py-3 bg-[#4DC3D1] text-white font-semibold rounded-full hover:bg-[#3a9ba8] transition-all duration-300 shadow-md hover:shadow-lg"
          >
            See More
          </button>
        </div>
      )}
    </div>
    </div>
    </section>
  )
}

export default Portfoliopage